var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrolleyIcon = function SvgTrolleyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.22 13.01c.92 0 1.72-.62 1.94-1.52l1.66-6.62c.11-.45.01-.92-.27-1.29S20.83 3 20.37 3H4.5L3.98.77C3.87.32 3.47 0 3.01 0H1C.45.01 0 .46 0 1.01s.45 1 1 1h1.21l3.17 13.48C4.55 16.02 4 16.95 4 18.01c0 1.65 1.35 3 3 3s3-1.35 3-3c0-.35-.07-.69-.18-1h5.37c-.11.31-.18.65-.18 1 0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3H7.32l-.47-2zm1.5-8-1.5 6H6.38l-1.41-6zM8 18.01c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m10 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
  })));
};
export default SvgTrolleyIcon;